import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=4e023dd1&scoped=true"
import script from "./Professional.vue?vue&type=script&lang=js"
export * from "./Professional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e023dd1",
  null
  
)

export default component.exports